module.exports = __webpack_public_path__ + "img/full4-min.b496a238.png";